// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from '../id.js'

export class BlockText {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): BlockText {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsBlockText(bb: flatbuffers.ByteBuffer, obj?: BlockText): BlockText {
    return (obj || new BlockText()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsBlockText(bb: flatbuffers.ByteBuffer, obj?: BlockText): BlockText {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new BlockText()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  blockId(obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Id()).__init(this.bb_pos + offset, this.bb!) : null
  }

  text(): string | null
  text(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  text(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  static startBlockText(builder: flatbuffers.Builder) {
    builder.startObject(2)
  }

  static addBlockId(builder: flatbuffers.Builder, blockIdOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, blockIdOffset, 0)
  }

  static addText(builder: flatbuffers.Builder, textOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, textOffset, 0)
  }

  static endBlockText(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 6) // text
    return offset
  }

  static createBlockText(
    builder: flatbuffers.Builder,
    blockIdOffset: flatbuffers.Offset,
    textOffset: flatbuffers.Offset
  ): flatbuffers.Offset {
    BlockText.startBlockText(builder)
    BlockText.addBlockId(builder, blockIdOffset)
    BlockText.addText(builder, textOffset)
    return BlockText.endBlockText(builder)
  }
}
